import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  readCombinedNotification,
  readNotification,
} from "data/server_apis/notificationService";
import { getCombinedNotifications } from "data/server_apis/notificationService";
import { getCombinedNotificationCount } from "data/server_apis/notificationService";

const combinedNotificationAdapter = createEntityAdapter({
  selectId: (notification) => `${notification.id}${notification.type}`,
});

export const getCombinedNotificationCountThunk = createAsyncThunk(
  "combinedNotification/count",
  async (_, { rejectWithValue }) => {
    try {
      return (await getCombinedNotificationCount()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getCombinedNotificationsThunk = createAsyncThunk(
  "combinedNotification/notifications",
  async (page, { rejectWithValue }) => {
    try {
      return (await getCombinedNotifications(page)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const readCombinedNotificationThunk = createAsyncThunk(
  "combinedNotification/read_notifications",
  async (notification, { rejectWithValue }) => {
    try {
      if (["error", "stock"].includes(notification.type)) {
        return (await readNotification(notification.id)).data;
      } else {
        return (await readCombinedNotification(notification.id)).data;
      }
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const combinedNotificationsSlice = createSlice({
  name: "notifications",
  initialState: combinedNotificationAdapter.getInitialState({
    status: {},
    count: 0,
    page_size: 1,
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getCombinedNotificationCountThunk.fulfilled,
      (state, action) => {
        state.status = { success: "get_count" };
        state.count = action.payload.count;
      }
    );

    builder
      .addCase(readCombinedNotificationThunk.fulfilled, (state, action) => {
        state.status = { success: "read" };
        state.count -= 1;
        combinedNotificationAdapter.updateOne(state, {
          id: `${action.payload.id}${action.payload.type}`,
          changes: { ...action.payload, read: true },
        });
      })
      .addCase(readCombinedNotificationThunk.pending, (state, action) => {
        state.status = { loading: "read", id: action.meta.arg.id };
      });
    builder
      .addCase(getCombinedNotificationsThunk.pending, (state, action) => {
        state.status = { loading: "get" };
      })
      .addCase(getCombinedNotificationsThunk.fulfilled, (state, action) => {
        state.status = { success: "get" };
        state.page_size = action.payload.total_pages;
        combinedNotificationAdapter.setAll(state, action.payload.results);
      });
  },
});

export const combinedNotificationSelector =
  combinedNotificationAdapter.getSelectors(
    (state) => state.combinedNotifications
  );

export const {} = combinedNotificationsSlice.actions;

export default combinedNotificationsSlice.reducer;
